import { ReactNode } from 'react';
import classNames from 'clsx';

import { FormLabel } from '../formlabel/FormLabel';

import styles from './section-header.module.scss';

SectionHeader.Label = SectionHeaderLabel;

export type SectionHeaderLabelProps = {
  children?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  separator?: boolean;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  className?: string;
  /** header size relative to 1 (em) */
  size?: number;
};

export function SectionHeaderLabel({
  children,
  title,
  description,
  separator,
  disabled,
  size = 1,
  className,
  ...labelProps
}: SectionHeaderLabelProps) {
  return (
    <div
      style={{ position: 'relative', fontSize: `${size}em` }}
      className={classNames(styles['label'], {
        'rje-section-header__label--disabled': disabled,
        'with-separator': separator,
        'with-description': !!description,
      })}
    >
      <FormLabel
        {...labelProps}
        className={className}
        disabled={disabled}
        label={children ?? title}
      />
      {separator && <div className={styles['separator']}></div>}
    </div>
  );
}

export function SectionHeader({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  return <div className={styles['header']}>{children}</div>;
}
